import { BackLink } from '../components/BackLink';
import { MaterialsMe } from './MaterialsMe';
import { MaterialsHeadshots } from './MaterialsHeadshots';
import { MaterialsResume } from './MaterialsResume';
import { MaterialsReels } from './MaterialsReels';
import type { MaterialsSection } from '../routes/route';
import './Materials.css';

export interface MaterialsProps {
  tenantId: string;
  userName: string;
  section: MaterialsSection;
  onBack: () => void;
  onNavigate: (section: MaterialsSection) => void;
}

// B5b — the Materials workshop, reached only via Today's own strip (This is me ·
// Headshots · Resume · Reels), never a top-level tab; "back to Today" (BackLink)
// is the one way out. This frame dispatches to the four real surfaces; each
// owns its own fetch + empty state (a first-run actor has no media/resume yet).
export function Materials({ tenantId, userName, section, onBack, onNavigate }: MaterialsProps) {
  return (
    <div class="materials">
      <div class="materials__back">
        <BackLink label="Today" onClick={onBack} />
      </div>
      {section === 'me' ? (
        <MaterialsMe tenantId={tenantId} userName={userName} onNavigate={onNavigate} />
      ) : section === 'headshots' ? (
        <MaterialsHeadshots tenantId={tenantId} />
      ) : section === 'resume' ? (
        <MaterialsResume tenantId={tenantId} />
      ) : (
        <MaterialsReels tenantId={tenantId} />
      )}
    </div>
  );
}
